export default __webpack_public_path__ + "static/media/lock-icon.e24bc2e6.svg";